import { Injectable } from '@angular/core';
import { Http, Response , Headers} from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { Observable } from 'rxjs/Observable';
import { Router} from '@angular/router';


@Injectable()
export class InterviewService {

  constructor(private http: Http,private router:Router) { }






   public u_userdata: [ {

                  username:string,
                    email:string,      
                    birthDate:string,
                    totalexp:string,
                    current_ctc:string,
                    expect_ctc:string,
                    notice_period:string,
                    skill1:string,
                    skill_rating1:string,
                    skill2:string,
                   skill_rating2:string,
                   skill3:string,
                    skill_rating3:string,
                      skill4:string,
                    skill_rating4:string,
                      skill5:string,
                    skill_rating5:string,
                    gender:string,
                    question1:string,
                    question2:string

   
     }];

   userData_fromC()
{
console.log('start');
  console.log(this.u_userdata);
console.log('end');
}

   public u_data = {};

    setValue(option, value) {

   
    this.u_data[option] = value;
    this.u_data[option] = value;
    this.u_data[option] = value;
    this.u_data[option] = value;
    this.u_data[option] = value;
    this.u_data[option] = value;
    this.u_data[option] = value;
    this.u_data[option] = value;
   this.u_data[option] = value;
    this.u_data[option] = value;
    this.u_data[option] = value;
    this.u_data[option] = value;
    this.u_data[option] = value;
    this.u_data[option] = value;


    }

    getdata() {

        return this.u_data;
    }   



    sendUserData()
    {

    console.log("in rating service"  +this.u_data["username"]);


   // const headers=new Headers({'Content-Type': 'application/json'}); 
    return this.http.get('http://gunadhyasoft.com/girswebservices/interviewfeedback.php?name= '+ this.u_data["username"] +'&email= '+this.u_data["email"] +'&education= '+ this.u_data["education"]+'&mobile_no='+this.u_data["mobile_no"]+'&birthdate='+ this.u_data["birthDate"] +'&totalexp= '+ this.u_data["totalexp"] +'&currentCTC= '+ this.u_data["current_ctc"] + '&expectCTC= '+ this.u_data["expect_ctc"] +'&noticePeriod= '+this.u_data["notice_period"] +'&skill1='+this.u_data["skill1"]+'&skill_rating1='+ this.u_data["skill_rating1"] +'&skill2='+this.u_data["skill2"]+'&skill_rating2='+ this.u_data["skill_rating2"] +'&skill3='+this.u_data["skill3"]+'&skill_rating3='+ this.u_data["skill_rating3"] +'&skill4='+this.u_data["skill4"]+'&skill_rating4='+ this.u_data["skill_rating4"] +'&skill5='+this.u_data["skill5"]+'&skill_rating5='+ this.u_data["skill_rating5"] +'&gender= '+ this.u_data["gender"] + '&question1= '+ this.u_data["question1"] +'&question2= '+ this.u_data["question2"] + '')
      .map(
     
    (response: Response)=>
      {
      
    if(response.json() == "Success")
    {
      console.log("In success");

      
      alert("Data submitted Successfully");
   this.router.navigate(['home']);
        return true;
    }

        alert("Data not submitted");

    }
    )



    

    }
   
    get_skills()
   {
       return this.http.get('http://gunadhyasoft.com/girswebservices/getskills.php?')
    .map(
    (response: Response)=>
      response.json())

    }
  
   }
  

    




// WEBPACK FOOTER //
// C:/Users/USer/Interviewfeedback/src/app/newinterviewreview/interview.service.ts